import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver';
import { HtmlVideoPath } from './HtmlVideoRenderPath';
export function createDefaultVideoRenderPaths() {
    return [new HtmlVideoPath()];
}
export function createVideoRenderPathResolver(paths = createDefaultVideoRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
